import { V } from '@angular/cdk/keycodes';
import { Component, Input,Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { NgxUiLoaderService } from "ngx-ui-loader";

@Component({
  selector: 'app-caseclaim',
  templateUrl: './caseclaim.component.html',
  styleUrls: ['./caseclaim.component.scss']
})
export class CaseclaimComponent {
// caseclaimdetails:any[]=[{ 
//   "ClaimNumber":  "claim12222243", 
//   "AccessionNumber" :  "acc12-345", 
//   "ClaimState":"Verified", 
//   "MilestoneDetails" : [ 
//    { 
//    "Milestone":  "Claim Created", 
//    "PerformedBy" : "jyothiswaroop.r@starmarkit.com", 
//    "PerformedDate" : "06-01-2025", 
//    "Notes" : "Demographics is completed for the case  Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case Demographics is completed for the case", 
//    "Sequence": "1" 
//   } , 
//   { 
//   "Milestone":  "Codes Verified", 
//   "PerformedBy" : "jyothiswaroop.r@starmarkit.com", 
//   "PerformedDate" : "06-01-2025", 
//   "Notes" : "Demographics is completed for the case" ,
//   "Sequence": "3" 
//  } , 
//  { 
//  "Milestone":  "Queued for Submission", 
//  "PerformedBy" : "jyothiswaroop.r@starmarkit.com", 
//  "PerformedDate" : "06-01-2025", 
//  "Notes" : "Demographics is completed for the case" ,
//  "Sequence": "4" 
// } ,
//    { 
//    "Milestone":  "Charges Verified", 
//    "PerformedBy" : "jyothiswaroop.r@starmarkit.com", 
//    "PerformedDate" : "06-01-2025", 
//    "Notes" : "Demographics is completed for the case" ,
//    "Sequence": "2" 
//   }
//   ] 
//    },
//    { 
//     "ClaimNumber":  "claim12222243", 
//     "AccessionNumber" :  "acc12-345", 
//     "ClaimState":"Verified", 
//     "MilestoneDetails" : [ 
//      { 
//      "Milestone":  "Claim Created", 
//      "PerformedBy" : "jyothiswaroop.r@starmarkit.com", 
//      "PerformedDate" : "06-01-2025", 
//      "Notes" : "Demographics is completed for the case", 
//      "Sequence": "1" 
//     } , 
//     { 
//     "Milestone":  "Codes Verified", 
//     "PerformedBy" : "jyothiswaroop.r@starmarkit.com", 
//     "PerformedDate" : "06-01-2025", 
//     "Notes" : "Demographics is completed for the case" ,
//     "Sequence": "3" 
//    } , 
//    { 
//    "Milestone":  "Queued for Submission", 
//    "PerformedBy" : "jyothiswaroop.r@starmarkit.com", 
//    "PerformedDate" : "06-01-2025", 
//    "Notes" : "Demographics is completed for the case" ,
//    "Sequence": "4" 
//   } ,
//      { 
//      "Milestone":  "Charges Verified", 
//      "PerformedBy" : "jyothiswaroop.r@starmarkit.com", 
//      "PerformedDate" : "06-01-2025", 
//      "Notes" : "Demographics is completed for the case" ,
//      "Sequence": "2" 
//     }
//     ] 
//      }];
caseclaimdetails:any[]=[];
//@Input() CaseDetails={};
isexpanded:boolean;
constructor(private service:CommonService,private ngxUiLoaderService: NgxUiLoaderService,private toastr:ToastrService,@Inject('caseData') public CaseDetails: any){}
ngOnInit() {
let labguid=this.CaseDetails["ServiceProvider"]['Type']=='Laboratory'?this.CaseDetails["ServiceProvider"]['Location']['OrganizationGUID']:''
let obj={
 "CaseGUID": this.CaseDetails["CaseGUID"], 
 "DeploymentKey": this.CaseDetails["DeploymentKey"] , 
 "LabGUID":labguid
}
this.getCaseClaimDetails(obj);
}
getCaseClaimDetails(obj){
  this.ngxUiLoaderService.start();
this.service.GetCaseClaimDetails(obj).subscribe((data:any)=>{
  this.ngxUiLoaderService.stop();
  if(data!=null){
      if(data['Status'].toLowerCase()!='success'){
        this.toastr.warning(data['Message'], "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }else{
        if(data['Data']==null || (data['Data'][0]['ClaimNumber']==null && data['Data'][0]['AccessionNumber']==null)){
          this.toastr.warning("Case Details Not Found", "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }else{
        this.caseclaimdetails=data['Data'];
        this.caseclaimdetails.forEach(V=>{
          V['MilestoneDetails'].sort((a,b)=>a.Sequence-b.Sequence);
        });
      }
      }
  }
})
}
expand(){
  this.isexpanded=!this.isexpanded;
}
}
